import {
  Datagrid,
  FunctionField,
  List,
  ShowButton,
  TextField,
} from "react-admin";
import { useAppSelector } from "../../store/hooks";
import ResourceSelectDialogButton from "../Common/ResourceSelectDialogButton";
import CommonFilterCard, { CommonFilterField } from "../Common/CommonFilterCard";
import StyledDatagridWrapper, { commonDatagridSx } from "../Common/StyledDatagridWrapper";

const filterFields: CommonFilterField[] = [
  { type: "text", label: "Search By Name", source: "name" },
  { type: "text", label: "Area Name", source: "areaName" },
  { type: "text", label: "City Name", source: "cityName" },
];

const HubsList = () => {
  const isCustomSelectOpen = useAppSelector(
    (state) => state.customSelect.value.open
  );
  return (
    <>
      <List
        actions={isCustomSelectOpen?false:undefined}
        sx={{
          "& .RaList-content": {
            boxShadow: "none",
            backgroundColor: "transparent",
          },
        }}
      >
        <>
        <CommonFilterCard fields={filterFields} />

        <br />

        <StyledDatagridWrapper title="Hubs">
        <Datagrid bulkActionButtons={false} size="medium" sx={commonDatagridSx}>
          {isCustomSelectOpen && <ResourceSelectDialogButton />}
          <TextField label="ID" source="id" />
          <TextField label="Name" source="name" />
          <TextField label="Area ID" source="areaId" />
          <TextField label="Area Name" source="areaName" />
          <TextField label="City Name" source="cityName" />
          <TextField label="City ID" source="cityId" />
          <TextField label="Latitude" source="coordinates.coordinates[1]" />
          <TextField label="Longitude" source="coordinates.coordinates[0]" />
          <FunctionField label="View" render={() => <ShowButton />} />
        </Datagrid>
        </StyledDatagridWrapper>
        </>
      </List>
    </>
  );
};

export default HubsList;
